import { ReactElement } from 'react';
import { tile } from '@interfaces/interfaces';
import { Field, useFormikContext } from 'formik';
import { TileRadioAccessible, Alert } from '@components';
import gridStyles from '@pages/forms/Grid.module.scss';
import { iReviewFormValues } from '@services/ReviewService';

// import { FormType } from '@constants/forms';
import IssueIcon from '../../../../images/issue.svg';
import InfoIcon from '../../../../images/info.svg';

function ReviewStep3(): ReactElement {
//   const context = useFormikContext();
  const YesValue = (): ReactElement => (
    <>
      <div>Yes</div>
    </>
  );

  const NoValue = (): ReactElement => (
    <>
      <div>No</div>
    </>
  );

  const TILE_DATA: tile[] = [
    {
      body: <YesValue />,
      value: 'true',
    },
    {
      body: <NoValue />,
      value: 'false',
    },
  ];

  const { values }: { values: iReviewFormValues } = useFormikContext();
  const WasSomeoneElseDrivingAtTimeOfOffenceAlert = (): ReactElement => (
    <>
      <br />
      <p>
        You should
        { ' '}
        <a href="/Nominate" target="_blank" rel="noopener noreferrer">
          nominate the driver
        </a>
        {' '}
        if:
        <ul>
          <li>someone else was the driver responsible for the vehicle at the time of the offence</li>
          <li>you sold the vehicle to someone else, or disposed of the vehicle before the offence date</li>
          <li>you believe the vehicle, or numberplates displayed on the vehicle, were stolen or cloned/copied</li>
          <li>you were incorrectly nominated as the responsible person.</li>
        </ul>
      </p>
      <p>
        Once the fine becomes a Notice of Final Demand, it is too late to nominate.
      </p>
    </>
  );
  const ApplyingForPenaltyReminderAlert = (): ReactElement => (
    <>
      <p>
        If your request is granted, only the Penalty Reminder fee will be removed.
      </p>
      <br />
      <p>
        The original fine amount will still need to be paid, and any demerit points or other sanctions will still apply.
      </p>
    </>
  );

  const HaveYouSubmittedEnforcementReviewBeforeAlert = (): ReactElement => (
    <>
      <br />
      <p>
        In most cases, you can only make
        {' '}
        <strong>one</strong>
        {' '}
        application for an enforcement review.
      </p>
      <br />
      <p>
        <a href="/Court-fines/Enforcement-Warrant" target="_blank" rel="noopener noreferrer">
          More information
        </a>
      </p>
    </>
  );

  return (
    <>
      <div className={gridStyles.form}>
        <span className="vfH2">Before you continue</span>
        {values.isDebtorTypeIndividual && values.isInternalReviewStage && (
          <>
            {values.isNominatable && (
            <div className={gridStyles.gridColFull}>
              <Field
                component={TileRadioAccessible}
                name="WasSomeoneElseDrivingAtTimeOfOffence"
                title="Are you the person named on the infringement notice, but someone else was driving at the time of the offence?"
                tileData={TILE_DATA}
                orientationRow
                isMandatory
                // autocomplete="off"
              />
              {values.WasSomeoneElseDrivingAtTimeOfOffence === 'true' && (
                <Alert
                  message={<WasSomeoneElseDrivingAtTimeOfOffenceAlert />}
                  theme="error"
                  title="You may be eligible to nominate the driver in possession of the vehicle/trailer at the time of the offence."
                  icon={IssueIcon}
                />
              )}
            </div>
            )}
            {values.Status === 'PenaltyReminder' && (
            <div className={gridStyles.gridColFull}>
              <Field
                name="ApplyingForPenaltyReminder"
                title="Are you applying to have the Penalty Reminder fee waived?"
                component={TileRadioAccessible}
                tileData={TILE_DATA}
                orientationRow
                isMandatory
              />
              {values.ApplyingForPenaltyReminder === 'true' && (
              <Alert
                message={<ApplyingForPenaltyReminderAlert />}
                theme="info"
                title=""
                icon={InfoIcon}
              />
              )}
            </div>
            )}
          </>
        )}
        {values.isEnforcementReviewStage && (
          <div className={gridStyles.gridColFull}>
            <Field
              name="HaveYouSubmittedEnforcementReviewBefore"
              title="Have you submitted an enforcement review application for this fine before?"
              component={TileRadioAccessible}
              tileData={TILE_DATA}
              orientationRow
              isMandatory
            />
            {values.HaveYouSubmittedEnforcementReviewBefore === 'true' && (
            <Alert
              message={<HaveYouSubmittedEnforcementReviewBeforeAlert />}
              theme="info"
              title="There is a limit to the number of times that you can apply"
              icon={InfoIcon}
            />
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default ReviewStep3;
